import type { IWorkflowStatus } from '@/domains/workflows/api/workflow';
import type { CasesPerStatusChartData } from '@/pages/Workflows/components/molecules/CasesPerStatusChart';
import { useMemo } from 'react';

import { CasesPerStatusChart } from '@/pages/Workflows/components/molecules/CasesPerStatusChart';
import { useCasesPerStatusQuery } from '@/pages/Workflows/components/organisms/metrics/CasesPerStatusStats/hooks/useCasesPerStatusQuery';

const statusToTitleMap: Record<IWorkflowStatus, string> = {
  active: 'Active',
  completed: 'Completed',
  failed: 'Failed',
};

export const CasesPerStatusStats = () => {
  const { data, isLoading } = useCasesPerStatusQuery();

  const chartData = useMemo(
    (): CasesPerStatusChartData[] =>
      Object.entries(data)
        .map(([status, count]) => ({
          id: status,
          status: statusToTitleMap[status as IWorkflowStatus] || status,
          casesCount: count,
        }))
        .sort((dataA, dataB) => dataA.status.localeCompare(dataB.status)),
    [data],
  );

  return <CasesPerStatusChart isLoading={isLoading} data={chartData} />;
};
